/**
 * Formats a profile picture URL to ensure it has the proper protocol
 * @param {string} url - The profile picture URL
 * @returns {string} - The formatted URL with https:// prefix if needed
 */
export const formatProfilePictureUrl = (url) => {
  if (!url) return null;
  
  // If the URL already starts with http:// or https://, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Otherwise, prepend https://
  return `https://${url}`;
};